import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type PortfolioProject = Database['public']['Tables']['portfolio_projects']['Row'];
type PortfolioProjectInsert = Database['public']['Tables']['portfolio_projects']['Insert'];
type PortfolioProjectUpdate = Database['public']['Tables']['portfolio_projects']['Update'];

export const portfolioService = {
  /**
   * Get current user's portfolio projects
   */
  getMyProjects: async (): Promise<PortfolioProject[]> => {
    const result = await apiClient.get<PortfolioProject[]>('/portfolio/projects');
    return result as unknown as PortfolioProject[];
  },
  
  /**
   * Get portfolio project by ID (public endpoint)
   */
  getProject: async (projectId: string): Promise<PortfolioProject> => {
    const result = await apiClient.get<PortfolioProject>(`/portfolio/projects/${projectId}`);
    return result as unknown as PortfolioProject;
  },
  
  /**
   * Get all portfolio projects for a freelancer profile (public endpoint)
   */
  getProjectsByProfile: async (profileId: string): Promise<PortfolioProject[]> => {
    const result = await apiClient.get<PortfolioProject[]>(`/portfolio/projects/profile/${profileId}`);
    return result as unknown as PortfolioProject[];
  },
  
  /**
   * Create a new portfolio project
   */
  createProject: async (data: Omit<PortfolioProjectInsert, 'freelancer_profile_id'>): Promise<PortfolioProject> => {
    const result = await apiClient.post<PortfolioProject>('/portfolio/projects', data);
    return result as unknown as PortfolioProject;
  },
  
  /**
   * Update a portfolio project
   */
  updateProject: async (projectId: string, data: PortfolioProjectUpdate): Promise<PortfolioProject> => {
    const result = await apiClient.patch<PortfolioProject>(`/portfolio/projects/${projectId}`, data);
    return result as unknown as PortfolioProject;
  },
  
  /**
   * Delete a portfolio project
   */
  deleteProject: async (projectId: string): Promise<void> => {
    await apiClient.delete(`/portfolio/projects/${projectId}`);
  },
};

